import { Notation } from 'types/notationSystem';
import { roundToTwoDecimals } from 'utils/roundToTwoDecimals';

const wrappedRangeLabel = (label, value) => `${label} (${value})`;

export function getNoteRange(index: number, notations: Notation[]) {
  const currentValue = notations[index].value;
  if (index <= 1) {
    return undefined;
  }
  if (index === 2 && index === notations.length - 1) {
    return { start: 0, end: 100 };
  }
  if (index === 2) {
    const nextValue = notations[index + 1].value;

    return {
      start: 0,
      end: currentValue + roundToTwoDecimals((nextValue - currentValue) / 2),
    };
  }
  if (index === notations.length - 1) {
    const previousValue = notations[index - 1].value;
    return {
      start:
        currentValue - roundToTwoDecimals((currentValue - previousValue) / 2),
      end: 100,
    };
  }
  const previousValue = notations[index - 1].value;
  const nextValue = notations[index + 1].value;
  return {
    start:
      currentValue - roundToTwoDecimals((currentValue - previousValue) / 2),
    end: currentValue + roundToTwoDecimals((nextValue - currentValue) / 2),
  };
}

export default function getRangeLabel(index, notations) {
  const range = getNoteRange(index, notations);
  const currentLabel = notations[index].label;
  if (!range) {
    return currentLabel;
  }
  const { start, end } = range;
  return wrappedRangeLabel(currentLabel, `${start} à ${end}`);
}
